import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Chip } from '@mui/material';
import type { EventSourceEnum } from 'app/types';

interface EventSourceChipProps {
  value: EventSourceEnum;
}

const COMMON_STYLE: React.CSSProperties = {
  color: '#1976D2',
  backgroundColor: '#E3F2FD',
};

const EventSourceChip: React.FC<EventSourceChipProps> = ({ value }) => {
  const styleMap = {
    insurer_data: COMMON_STYLE,
    salary_package: COMMON_STYLE,
    system: {
      color: '#0097A7',
      backgroundColor: '#E0F2F1',
    },
    system_new_year: {
      color: '#0097A7',
      backgroundColor: '#E0F2F1',
    },
    baseline_measurement: COMMON_STYLE,
    ocr: COMMON_STYLE,
    unknown: {
      color: '#616161',
      backgroundColor: '#F5F5F5',
    },
    user: COMMON_STYLE,
    user_csv: COMMON_STYLE,
    salary_table: {
      color: '#ff5e5e',
      backgroundColor: '#f5e8ea',
    },
  };

  if (!value) {
    return null;
  }

  return <Chip sx={styleMap[value] || {}} label={<FormattedMessage id={`events.content.eventSource.${value}`} />} />;
};

export default EventSourceChip;
